export default __webpack_public_path__ + "static/media/GitLab.c8c449f1.svg";